/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export type IAPI76706ResDataItemFieldValueObj = {};
    
  
    
export interface IAPI76706ResDataItem {
  
  /** 字段名称 */
  fieldName?: string;
  
  /** 字段描述 */
  fieldDescription?: string;
  
  /** selectinputdate */
  fieldType?: string;
  
  /** 字段值 ,Object */
  fieldValue?: IAPI76706ResDataItemFieldValueObj;
  
  /** 字段编号 */
  fieldValueNo?: string;
  
  /** 字段接口编号 */
  fieldDataType?: string;
  
};
    
  



export interface API76706Req {
  
    bizNo: string;
  
};



export type API76706Res = IAPI76706ResDataItem[];


// 接口函数 76706 要素查询

export interface IUseGetAPI76706Return {
  /** 要素查询: 接口请求状态 */
  isAPI76706Loading: boolean;
  /** 要素查询: 接口请求返回数据 */
  dataAPI76706: API76706Res;
  /**  要素查询: 接口数据请求方法 */
  fetchAPI76706Data: (inputs: API76706Req, config?: YWRequestConfig) => Promise<API76706Res>;
  /** 要素查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76706 = ():IUseGetAPI76706Return => {
  let isMount = true;
  const [isAPI76706Loading, setIsAPI76706Loading] = useState(false);
  const [dataAPI76706, setDataAPI76706] = useState<API76706Res>({} as API76706Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/field/condition`;

  const fetchAPI76706Data = async (inputs: API76706Req, config?: YWRequestConfig): Promise<API76706Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76706Req>) || {}) as API76706Req;
    
  
    if ( isMount ) {
      setIsAPI76706Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76706Res>(`${basePath}/yoaichat-web/task/instance/field/condition/${parseParams<API76706Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76706(res || {} as API76706Res);
        setIsAPI76706Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76706Loading(false);
      }
      return false as unknown as API76706Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76706Loading,
    dataAPI76706,
    fetchAPI76706Data,
    requestUrl,
  }
}

